// source: yolabs/services/poplarfrontend/enums.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = function () {
  if (this) {
    return this;
  }
  if (typeof window !== 'undefined') {
    return window;
  }
  if (typeof global !== 'undefined') {
    return global;
  }
  if (typeof self !== 'undefined') {
    return self;
  }
  return Function('return this')();
}.call(null);

goog.exportSymbol('proto.yolabs.services.poplarfrontend.BadgeState', null, global);
goog.exportSymbol('proto.yolabs.services.poplarfrontend.CalendarAccessLevel', null, global);
goog.exportSymbol('proto.yolabs.services.poplarfrontend.ChoiceDataType', null, global);
goog.exportSymbol('proto.yolabs.services.poplarfrontend.Cuisine', null, global);
goog.exportSymbol('proto.yolabs.services.poplarfrontend.Diet', null, global);
goog.exportSymbol('proto.yolabs.services.poplarfrontend.EducationLevelOption', null, global);
goog.exportSymbol('proto.yolabs.services.poplarfrontend.FileInfoStatus', null, global);
goog.exportSymbol('proto.yolabs.services.poplarfrontend.FileMimeType', null, global);
goog.exportSymbol('proto.yolabs.services.poplarfrontend.FoodAllergy', null, global);
goog.exportSymbol('proto.yolabs.services.poplarfrontend.GeneralFeedback', null, global);
goog.exportSymbol('proto.yolabs.services.poplarfrontend.HistoryEventType', null, global);
goog.exportSymbol('proto.yolabs.services.poplarfrontend.HomeOwnershipTypeOption', null, global);
goog.exportSymbol('proto.yolabs.services.poplarfrontend.HomeResidencyTypeOption', null, global);
goog.exportSymbol('proto.yolabs.services.poplarfrontend.HomeType', null, global);
goog.exportSymbol('proto.yolabs.services.poplarfrontend.LineItemType', null, global);
goog.exportSymbol('proto.yolabs.services.poplarfrontend.ListPersonFilterOption', null, global);
goog.exportSymbol('proto.yolabs.services.poplarfrontend.MetadataType', null, global);
goog.exportSymbol('proto.yolabs.services.poplarfrontend.OptionCostType', null, global);
goog.exportSymbol('proto.yolabs.services.poplarfrontend.PetGender', null, global);
goog.exportSymbol('proto.yolabs.services.poplarfrontend.ProjectLabel', null, global);
goog.exportSymbol('proto.yolabs.services.poplarfrontend.PronounsOption', null, global);
goog.exportSymbol('proto.yolabs.services.poplarfrontend.ProposalEntryOptionStatus', null, global);
goog.exportSymbol('proto.yolabs.services.poplarfrontend.ProposalEntryOptionType', null, global);
goog.exportSymbol('proto.yolabs.services.poplarfrontend.ProposalEntryStatus', null, global);
goog.exportSymbol('proto.yolabs.services.poplarfrontend.ProposalEntryType', null, global);
goog.exportSymbol('proto.yolabs.services.poplarfrontend.ProposalOptionLabel', null, global);
goog.exportSymbol('proto.yolabs.services.poplarfrontend.ProposalStatus', null, global);
goog.exportSymbol('proto.yolabs.services.poplarfrontend.ProposalType', null, global);
goog.exportSymbol('proto.yolabs.services.poplarfrontend.PurchaseType', null, global);
goog.exportSymbol('proto.yolabs.services.poplarfrontend.Relationship', null, global);
goog.exportSymbol('proto.yolabs.services.poplarfrontend.SecureInfoDeletionType', null, global);
goog.exportSymbol('proto.yolabs.services.poplarfrontend.SecureInfoType', null, global);
goog.exportSymbol('proto.yolabs.services.poplarfrontend.SocialMediaPlatform', null, global);
goog.exportSymbol('proto.yolabs.services.poplarfrontend.StarRating', null, global);
goog.exportSymbol('proto.yolabs.services.poplarfrontend.TaskCancelFeedback', null, global);
goog.exportSymbol('proto.yolabs.services.poplarfrontend.TaskCategory', null, global);
goog.exportSymbol('proto.yolabs.services.poplarfrontend.TaskFeedbackType', null, global);
goog.exportSymbol(
  'proto.yolabs.services.poplarfrontend.TaskIntakeRelativeDueDateType',
  null,
  global
);
goog.exportSymbol('proto.yolabs.services.poplarfrontend.TaskTemplateCardType', null, global);
goog.exportSymbol('proto.yolabs.services.poplarfrontend.TaskTemplateType', null, global);
goog.exportSymbol('proto.yolabs.services.poplarfrontend.TaskType', null, global);
goog.exportSymbol('proto.yolabs.services.poplarfrontend.TaskViewType', null, global);
goog.exportSymbol('proto.yolabs.services.poplarfrontend.TimeOfDay', null, global);
goog.exportSymbol('proto.yolabs.services.poplarfrontend.TodoLabel', null, global);
goog.exportSymbol('proto.yolabs.services.poplarfrontend.UpdateTaskIndicesViewType', null, global);
goog.exportSymbol('proto.yolabs.services.poplarfrontend.UserRegistrationType', null, global);
goog.exportSymbol('proto.yolabs.services.poplarfrontend.WaitlistUserLifecycleStatus', null, global);
/**
 * @enum {number}
 */
proto.yolabs.services.poplarfrontend.UserRegistrationType = {
  USER_REGISTRATION_TYPE_UNSPECIFIED: 0,
  USER_REGISTRATION_TYPE_AUTH0: 1,
  USER_REGISTRATION_TYPE_APPLE: 2,
  USER_REGISTRATION_TYPE_FACEBOOK: 3,
  USER_REGISTRATION_TYPE_GOOGLE: 4,
};

/**
 * @enum {number}
 */
proto.yolabs.services.poplarfrontend.TaskViewType = {
  TASK_VIEW_TYPE_UNSPECIFIED: 0,
  TASK_VIEW_TYPE_IN_PROGRESS: 1,
  TASK_VIEW_TYPE_UPCOMING: 2,
  TASK_VIEW_TYPE_COMPLETED: 3,
  TASK_VIEW_TYPE_MY_TO_DOS: 4,
};

/**
 * @enum {number}
 */
proto.yolabs.services.poplarfrontend.TaskType = {
  TASK_TYPE_UNSPECIFIED: 0,
  TASK_TYPE_PROJECT: 1,
  TASK_TYPE_TODO: 2,
};

/**
 * @enum {number}
 */
proto.yolabs.services.poplarfrontend.ProjectLabel = {
  PROJECT_LABEL_UNSPECIFIED: 0,
  PROJECT_LABEL_REP_HAS_THE_BATON: 1,
  PROJECT_LABEL_MEMBER_HAS_THE_BATON: 2,
  PROJECT_LABEL_COMPLETE: 3,
  PROJECT_LABEL_CANCELLED: 4,
  PROJECT_LABEL_ON_HOLD: 5,
};

/**
 * @enum {number}
 */
proto.yolabs.services.poplarfrontend.TodoLabel = {
  TODO_LABEL_UNSPECIFIED: 0,
  TODO_LABEL_DRAFT: 1,
  TODO_LABEL_REP_HAS_THE_BATON: 2,
  TODO_LABEL_MEMBER_HAS_THE_BATON: 3,
  TODO_LABEL_COMPLETE: 4,
  TODO_LABEL_CANCELLED: 5,
  TODO_LABEL_ON_HOLD: 6,
  TODO_LABEL_HANDED_OFF_TO_REP: 7,
  TODO_LABEL_PENDING_COMPLETE: 8,
};

/**
 * @enum {number}
 */
proto.yolabs.services.poplarfrontend.BadgeState = {
  BADGE_STATE_UNSPECIFIED: 0,
  BADGE_STATE_PROPOSAL_READY: 1,
  BADGE_STATE_NEW_CHANNEL_MESSAGES: 2,
  BADGE_STATE_MULTIPLE_ITEMS_TO_REVIEW: 3,
  BADGE_STATE_READY_FOR_GENERAL_FEEDBACK: 4,
  BADGE_STATE_CHANNEL_UNREAD_COMMENTS: 5,
};

/**
 * @enum {number}
 */
proto.yolabs.services.poplarfrontend.TaskCategory = {
  TASK_CATEGORY_UNSPECIFIED: 0,
  TASK_CATEGORY_HOME_AND_GARDEN: 1,
  TASK_CATEGORY_FAMILY_CARE: 2,
  TASK_CATEGORY_RECREATION_QUALITY_TIME: 3,
  TASK_CATEGORY_SELF_CARE: 4,
  TASK_CATEGORY_CELEBRATION_AND_GIFTS: 5,
  TASK_CATEGORY_COMMUNITY: 6,
  TASK_CATEGORY_OTHER: 7,
};

/**
 * @enum {number}
 */
proto.yolabs.services.poplarfrontend.TaskFeedbackType = {
  TASK_FEEDBACK_TYPE_UNSPECIFIED: 0,
  TASK_FEEDBACK_TYPE_GENERAL: 1,
  TASK_FEEDBACK_TYPE_CANCEL: 2,
  TASK_FEEDBACK_TYPE_ON_HOLD: 3,
  TASK_FEEDBACK_TYPE_GENERAL_V2: 4,
  TASK_FEEDBACK_TYPE_MARK_AS_COMPLETED: 5,
};

/**
 * @enum {number}
 */
proto.yolabs.services.poplarfrontend.GeneralFeedback = {
  GENERAL_FEEDBACK_UNSPECIFIED: 0,
  GENERAL_FEEDBACK_OVERALL_GREAT: 1,
  GENERAL_FEEDBACK_COULD_HAVE_BEEN_BETTER: 2,
  GENERAL_FEEDBACK_SKIPPED: 3,
};

/**
 * @enum {number}
 */
proto.yolabs.services.poplarfrontend.TaskCancelFeedback = {
  TASK_CANCEL_FEEDBACK_UNSPECIFIED: 0,
  TASK_CANCEL_FEEDBACK_NO_LONGER_NEEDED: 1,
  TASK_CANCEL_FEEDBACK_TAKING_CARE_OF_IT_MYSELF: 2,
  TASK_CANCEL_FEEDBACK_TAKING_TOO_LONG: 3,
  TASK_CANCEL_FEEDBACK_OUT_OF_MY_BUDGET: 4,
  TASK_CANCEL_FEEDBACK_OTHER: 5,
};

/**
 * @enum {number}
 */
proto.yolabs.services.poplarfrontend.TaskIntakeRelativeDueDateType = {
  TASK_INTAKE_RELATIVE_DATE_TYPE_UNSPECIFIED: 0,
  TASK_INTAKE_RELATIVE_DATE_TYPE_WITHIN_A_WEEK: 1,
  TASK_INTAKE_RELATIVE_DATE_TYPE_WITHIN_A_MONTH: 2,
  TASK_INTAKE_RELATIVE_DATE_TYPE_NOT_SURE_YET: 3,
};

/**
 * @enum {number}
 */
proto.yolabs.services.poplarfrontend.UpdateTaskIndicesViewType = {
  UPDATE_TASK_INDICES_VIEW_TYPE_UNSPECIFIED: 0,
  UPDATE_TASK_INDICES_VIEW_TYPE_TASK_MY_TO_DOS: 1,
  UPDATE_TASK_INDICES_VIEW_TYPE_UPCOMING: 2,
};

/**
 * @enum {number}
 */
proto.yolabs.services.poplarfrontend.ProposalStatus = {
  PROPOSAL_STATUS_UNSPECIFIED: 0,
  PROPOSAL_STATUS_PUBLISHED: 1,
  PROPOSAL_STATUS_CONFIRMED: 2,
  PROPOSAL_STATUS_REJECTED: 3,
  PROPOSAL_STATUS_CANCELLED: 4,
  PROPOSAL_STATUS_COMPLETED: 5,
};

/**
 * @enum {number}
 */
proto.yolabs.services.poplarfrontend.ProposalOptionLabel = {
  PROPOSAL_OPTION_LABEL_UNSPECIFIED: 0,
  PROPOSAL_OPTION_LABEL_RECOMMENDED: 1,
};

/**
 * @enum {number}
 */
proto.yolabs.services.poplarfrontend.ProposalType = {
  PROPOSAL_TYPE_UNSPECIFIED: 0,
  PROPOSAL_TYPE_RESEARCH_CONTENT: 1,
  PROPOSAL_TYPE_SINGLE_CONTENT: 2,
  PROPOSAL_TYPE_MULTIPLE_CONTENT: 3,
};

/**
 * @enum {number}
 */
proto.yolabs.services.poplarfrontend.ProposalEntryType = {
  PROPOSAL_ENTRY_TYPE_UNSPECIFIED: 0,
  PROPOSAL_ENTRY_TYPE_RESEARCH_CONTENT: 1,
  PROPOSAL_ENTRY_TYPE_SINGLE_CONTENT: 2,
};

/**
 * @enum {number}
 */
proto.yolabs.services.poplarfrontend.ProposalEntryStatus = {
  PROPOSAL_ENTRY_STATUS_UNSPECIFIED: 0,
  PROPOSAL_ENTRY_STATUS_ACTIVE: 1,
  PROPOSAL_ENTRY_STATUS_REMOVED: 2,
};

/**
 * @enum {number}
 */
proto.yolabs.services.poplarfrontend.ProposalEntryOptionStatus = {
  PROPOSAL_ENTRY_OPTION_STATUS_UNSPECIFIED: 0,
  PROPOSAL_ENTRY_OPTION_STATUS_SELECTED: 1,
  PROPOSAL_ENTRY_OPTION_STATUS_UNSELECTED: 2,
};

/**
 * @enum {number}
 */
proto.yolabs.services.poplarfrontend.ProposalEntryOptionType = {
  PROPOSAL_ENTRY_OPTION_TYPE_UNSPECIFIED: 0,
  PROPOSAL_ENTRY_OPTION_TYPE_GENERAL: 1,
  PROPOSAL_ENTRY_OPTION_TYPE_CONTRACTED_PRO: 2,
  PROPOSAL_ENTRY_OPTION_TYPE_REFERRAL_PRO: 3,
  PROPOSAL_ENTRY_OPTION_TYPE_OUT_OF_NETWORK_PRO: 4,
};

/**
 * @enum {number}
 */
proto.yolabs.services.poplarfrontend.OptionCostType = {
  OPTION_COST_TYPE_UNSPECIFIED: 0,
  OPTION_COST_TYPE_YO_PAY: 1,
  OPTION_COST_TYPE_MEMBER_PAY: 2,
  OPTION_COST_TYPE_MEMBER_PAY_BY_OFFLINE_PAYMENT: 3,
};

/**
 * @enum {number}
 */
proto.yolabs.services.poplarfrontend.PurchaseType = {
  PURCHASE_TYPE_UNSPECIFIED: 0,
  PURCHASE_TYPE_YO_PAY: 1,
  PURCHASE_TYPE_MEMBER_PAY: 2,
};

/**
 * @enum {number}
 */
proto.yolabs.services.poplarfrontend.LineItemType = {
  LINE_ITEM_TYPE_UNSPECIFIED: 0,
  LINE_ITEM_TYPE_BASE_PRICE: 1,
  LINE_ITEM_TYPE_SHIPPING: 2,
  LINE_ITEM_TYPE_TAX: 3,
  LINE_ITEM_TYPE_MERCHANT_FEES: 4,
  LINE_ITEM_TYPE_PROCESSING_FEE: 5,
  LINE_ITEM_TYPE_DETAILED_PRICE_WITH_TAX_RATE_AND_UNIT: 6,
};

/**
 * @enum {number}
 */
proto.yolabs.services.poplarfrontend.FileInfoStatus = {
  FILE_INFO_STATUS_UNSPECIFIED: 0,
  FILE_INFO_STATUS_PENDING: 1,
  FILE_INFO_STATUS_UPLOADED: 2,
  FILE_INFO_STATUS_PROCESSED: 3,
  FILE_INFO_STATUS_FAILED: 4,
  FILE_INFO_STATUS_PROCESSED_NO_THUMBMAIL: 5,
};

/**
 * @enum {number}
 */
proto.yolabs.services.poplarfrontend.FileMimeType = {
  FILE_MIME_TYPE_UNSPECIFIED: 0,
  FILE_MIME_TYPE_JPEG: 1,
  FILE_MIME_TYPE_PNG: 2,
  FILE_MIME_TYPE_PDF: 3,
  FILE_MIME_TYPE_HEIC: 4,
  FILE_MIME_TYPE_MOV: 5,
  FILE_MIME_TYPE_MP4: 6,
  FILE_MIME_TYPE_GIF: 7,
  FILE_MIME_TYPE_DOC: 8,
  FILE_MIME_TYPE_EXCEL: 9,
  FILE_MIME_TYPE_PLAIN_TEXT: 10,
};

/**
 * @enum {number}
 */
proto.yolabs.services.poplarfrontend.PronounsOption = {
  PRONOUNS_OPTION_UNSPECIFIED: 0,
  PRONOUNS_OPTION_THEY: 1,
  PRONOUNS_OPTION_SHE: 2,
  PRONOUNS_OPTION_HE: 3,
  PRONOUNS_OPTION_RATHER_NOT_SAY: 4,
  PRONOUNS_OPTION_OTHER: 5,
};

/**
 * @enum {number}
 */
proto.yolabs.services.poplarfrontend.Relationship = {
  RELATIONSHIP_UNSPECIFIED: 0,
  RELATIONSHIP_SELF: 1,
  RELATIONSHIP_SPOUSE_OR_PARTNER: 2,
  RELATIONSHIP_CHILD: 15,
  RELATIONSHIP_PARENT: 4,
  RELATIONSHIP_SIBLING: 5,
  RELATIONSHIP_GRANDPARENT: 6,
  RELATIONSHIP_GRANDCHILD: 7,
  RELATIONSHIP_AUNT_OR_UNCLE: 8,
  RELATIONSHIP_NIECE_OR_NEPHEW: 9,
  RELATIONSHIP_COUSIN: 10,
  RELATIONSHIP_PARENT_IN_LAW: 11,
  RELATIONSHIP_SIBLING_IN_LAW: 12,
  RELATIONSHIP_FRIEND: 13,
  RELATIONSHIP_OTHER: 14,
  RELATIONSHIP_PRIMARY_OPTION_CHILD: 3,
};

/**
 * @enum {number}
 */
proto.yolabs.services.poplarfrontend.Diet = {
  DIET_UNSPECIFIED: 0,
  DIET_VEGETARIAN: 1,
  DIET_VEGAN: 2,
  DIET_PESCATARIAN: 3,
  DIET_KOSHER: 4,
  DIET_HALAL: 5,
  DIET_KETO: 6,
  DIET_GLUTEN_FREE: 7,
  DIET_DAIRY_FREE: 8,
  DIET_SOY_FREE: 9,
  DIETARY_OTHER: 10,
  DIET_ORGANIC: 11,
  DIET_FOR_HYPERTENSION: 12,
  DIET_HIGH_PROTEIN: 13,
  DIET_LOW_CARBS: 14,
};

/**
 * @enum {number}
 */
proto.yolabs.services.poplarfrontend.FoodAllergy = {
  FOOD_ALLERGY_UNSPECIFIED: 0,
  FOOD_ALLERGY_WHEAT: 1,
  FOOD_ALLERGY_PEANUTS: 2,
  FOOD_ALLERGY_TREE_NUTS: 3,
  FOOD_ALLERGY_SHELLFISH: 4,
  FOOD_ALLERGY_EGGS: 5,
  FOOD_ALLERGY_MILK: 6,
  FOOD_ALLERGY_FISH: 7,
  FOOD_ALLERGY_SOY: 8,
  FOOD_ALLERGY_SESAME: 9,
  FOOD_ALLERGY_OTHER: 10,
  FOOD_ALLERGY_FRUITS: 11,
  FOOD_ALLERGY_BUCKWHEAT: 12,
  FOOD_ALLERGY_FISH_EGGS: 13,
};

/**
 * @enum {number}
 */
proto.yolabs.services.poplarfrontend.Cuisine = {
  CUISINE_UNSPECIFIED: 0,
  CUISINE_AMERICAN: 1,
  CUISINE_ITALIAN: 2,
  CUISINE_INDIAN: 3,
  CUISINE_CHINESE: 4,
  CUISINE_JAPANESE: 5,
  CUISINE_MEXICAN: 6,
  CUISINE_THAI: 7,
  CUISINE_KOREAN: 8,
  CUISINE_VIETNAMESE: 9,
  CUISINE_GREEK: 10,
  CUISINE_HALAL: 11,
  CUISINE_HEALTHY: 12,
  CUISINE_OTHER: 13,
  CUISINE_WESTERN: 14,
  CUISINE_FRENCH: 15,
  CUISINE_SPANISH: 16,
  CUISINE_FAST_FOOD: 17,
  CUISINE_BUFFET: 18,
};

/**
 * @enum {number}
 */
proto.yolabs.services.poplarfrontend.TimeOfDay = {
  TIME_OF_DAY_UNSPECIFIED: 0,
  TIME_OF_DAY_MORNING: 1,
  TIME_OF_DAY_AFTERNOON: 2,
  TIME_OF_DAY_EVENING: 3,
};

/**
 * @enum {number}
 */
proto.yolabs.services.poplarfrontend.EducationLevelOption = {
  EDUCATION_LEVEL_OPTION_UNSPECIFIED: 0,
  EDUCATION_LEVEL_OPTION_PRESCHOOL: 1,
  EDUCATION_LEVEL_OPTION_KINDERGARTEN_THROUGH_2ND: 2,
  EDUCATION_LEVEL_OPTION_3RD_THROUGH_5TH: 3,
  EDUCATION_LEVEL_OPTION_MIDDLE_SCHOOL: 4,
  EDUCATION_LEVEL_OPTION_HIGH_SCHOOL: 5,
  EDUCATION_LEVEL_OPTION_UNDERGRADUATE: 6,
  EDUCATION_LEVEL_OPTION_GRADUATE: 7,
  EDUCATION_LEVEL_OPTION_OTHER: 8,
};

/**
 * @enum {number}
 */
proto.yolabs.services.poplarfrontend.SocialMediaPlatform = {
  SOCIAL_MEDIA_PLATFORM_UNSPECIFIED: 0,
  SOCIAL_MEDIA_PLATFORM_INSTAGRAM: 1,
  SOCIAL_MEDIA_PLATFORM_PINTEREST: 2,
  SOCIAL_MEDIA_PLATFORM_SPOTIFY: 3,
  SOCIAL_MEDIA_PLATFORM_TIKTOK: 4,
  SOCIAL_MEDIA_PLATFORM_OTHER: 5,
};

/**
 * @enum {number}
 */
proto.yolabs.services.poplarfrontend.PetGender = {
  PET_GENDER_UNSPECIFIED: 0,
  PET_GENDER_FEMALE: 1,
  PET_GENDER_MALE: 2,
};

/**
 * @enum {number}
 */
proto.yolabs.services.poplarfrontend.HomeOwnershipTypeOption = {
  HOME_OWNERSHIP_TYPE_OPTION_UNSPECIFIED: 0,
  HOME_OWNERSHIP_TYPE_OPTION_OWN: 1,
  HOME_OWNERSHIP_TYPE_OPTION_RENT: 2,
  HOME_OWNERSHIP_TYPE_OPTION_OTHER: 3,
};

/**
 * @enum {number}
 */
proto.yolabs.services.poplarfrontend.HomeResidencyTypeOption = {
  HOME_RESIDENCY_TYPE_OPTION_UNSPECIFIED: 0,
  HOME_RESIDENCY_TYPE_OPTION_PRIMARY_RESIDENCE: 1,
  HOME_RESIDENCY_TYPE_OPTION_RENTAL_PROPERTY: 2,
  HOME_RESIDENCY_TYPE_OPTION_VACATION_HOME: 3,
  HOME_RESIDENCY_TYPE_OPTION_OTHER: 4,
  HOME_RESIDENCY_TYPE_OPTION_DO_NOT_LIVE_HERE: 5,
};

/**
 * @enum {number}
 */
proto.yolabs.services.poplarfrontend.HomeType = {
  HOME_TYPE_UNSPECIFIED: 0,
  HOME_TYPE_SINGLE_FAMILY: 1,
  HOME_TYPE_MULTI_FAMILY: 2,
  HOME_TYPE_APARTMENT: 3,
  HOME_TYPE_CONDOMINIUM: 4,
  HOME_TYPE_TOWNHOUSE: 5,
  HOME_TYPE_CO_OP: 6,
  HOME_TYPE_MOBILE_HOME: 7,
  HOME_TYPE_MODULAR_HOME: 8,
  HOME_TYPE_OTHER: 9,
};

/**
 * @enum {number}
 */
proto.yolabs.services.poplarfrontend.ListPersonFilterOption = {
  FILTER_OPTION_UNSPECIFIED: 0,
  FILTER_OPTION_PRIMARY_ONLY: 1,
  FILTER_OPTION_EXCLUDE_PRIMARY: 2,
  FILTER_OPTION_ALL: 3,
};

/**
 * @enum {number}
 */
proto.yolabs.services.poplarfrontend.MetadataType = {
  META_DATA_TYPE_UNSPECIFIED: 0,
  META_DATA_TYPE_WEB: 1,
  META_DATA_TYPE_IMAGE: 2,
  META_DATA_TYPE_VIDEO: 3,
};

/**
 * @enum {number}
 */
proto.yolabs.services.poplarfrontend.WaitlistUserLifecycleStatus = {
  WAITLIST_USER_LIFECYCLE_STATUS_UNSPECIFIED: 0,
  WAITLIST_USER_LIFECYCLE_STATUS_APPLIED: 1,
  WAITLIST_USER_LIFECYCLE_STATUS_INVITED: 2,
  WAITLIST_USER_LIFECYCLE_STATUS_INVITATION_ACCEPTED: 3,
  WAITLIST_USER_LIFECYCLE_STATUS_SUBSCRIPTION_PURCHASED: 4,
  WAITLIST_USER_LIFECYCLE_STATUS_INTERVIEW_SCHEDULED: 5,
  WAITLIST_USER_LIFECYCLE_STATUS_INVITATION_EXPIRED: 6,
  WAITLIST_USER_LIFECYCLE_STATUS_DIRECT_PURCHASE_ACCOUNT_CREATED: 7,
};

/**
 * @enum {number}
 */
proto.yolabs.services.poplarfrontend.StarRating = {
  STAR_RATING_UNSPECIFIED: 0,
  STAR_RATING_ONE_STAR: 1,
  STAR_RATING_TWO_STARS: 2,
  STAR_RATING_THREE_STARS: 3,
  STAR_RATING_FOUR_STARS: 4,
  STAR_RATING_FIVE_STARS: 5,
};

/**
 * @enum {number}
 */
proto.yolabs.services.poplarfrontend.CalendarAccessLevel = {
  CALENDAR_ACCESS_LEVEL_UNSPECIFIED: 0,
  CALENDAR_ACCESS_LEVEL_READ_ONLY_FREE_BUSY: 1,
  CALENDAR_ACCESS_LEVEL_READ_ONLY_ALL: 2,
  CALENDAR_ACCESS_LEVEL_READ_WRITE: 3,
  CALENDAR_ACCESS_LEVEL_FULL: 4,
  CALENDAR_ACCESS_LEVEL_LIMITED: 5,
  CALENDAR_ACCESS_LEVEL_READ_ONLY: 6,
};

/**
 * @enum {number}
 */
proto.yolabs.services.poplarfrontend.ChoiceDataType = {
  CHOICE_DATA_TYPE_UNSPECIFIED: 0,
  CHOICE_DATA_TYPE_STRING: 1,
  CHOICE_DATA_TYPE_POSTAL_ADDRESS: 2,
  CHOICE_DATA_TYPE_DATE: 3,
  CHOICE_DATA_TYPE_DATE_TIME: 4,
  CHOICE_DATA_TYPE_LOCALIZED_TEXT: 5,
};

/**
 * @enum {number}
 */
proto.yolabs.services.poplarfrontend.TaskTemplateCardType = {
  TASK_TEMPLATE_CARD_TYPE_UNSPECIFIED: 0,
  TASK_TEMPLATE_CARD_TYPE_FEATURED: 1,
};

/**
 * @enum {number}
 */
proto.yolabs.services.poplarfrontend.TaskTemplateType = {
  TASK_TEMPLATE_TYPE_UNSPECIFIED: 0,
  TASK_TEMPLATE_TYPE_A: 1,
  TASK_TEMPLATE_TYPE_B: 2,
  TASK_TEMPLATE_TYPE_C: 3,
  TASK_TEMPLATE_TYPE_D: 4,
};

/**
 * @enum {number}
 */
proto.yolabs.services.poplarfrontend.SecureInfoType = {
  SECURE_INFO_TYPE_UNSPECIFIED: 0,
  SECURE_INFO_TYPE_ACCOUNT_SECURITY_CODE: 1,
  SECURE_INFO_TYPE_DRIVERS_LICENSE: 2,
  SECURE_INFO_TYPE_GIFT_CARD: 3,
  SECURE_INFO_TYPE_HEALTH_INSURANCE_ID: 4,
  SECURE_INFO_TYPE_DENTAL_INSURANCE_ID: 5,
  SECURE_INFO_TYPE_LOGIN_CREDENTIALS: 6,
  SECURE_INFO_TYPE_PASSPORT_NUMBER: 7,
  SECURE_INFO_TYPE_PAYMENT_CARD: 8,
  SECURE_INFO_TYPE_SOCIAL_SECURITY_NUMBER: 9,
  SECURE_INFO_TYPE_TSA_GLOBAL_ENTRY: 10,
};

/**
 * @enum {number}
 */
proto.yolabs.services.poplarfrontend.HistoryEventType = {
  HISTORY_EVENT_TYPE_UNSPECIFIED: 0,
  HISTORY_EVENT_TYPE_METADATA_CREATED: 1,
  HISTORY_EVENT_TYPE_DATA_REVEALED: 2,
  HISTORY_EVENT_TYPE_METADATA_UPDATED: 3,
  HISTORY_EVENT_TYPE_DATA_DELETED: 4,
};

/**
 * @enum {number}
 */
proto.yolabs.services.poplarfrontend.SecureInfoDeletionType = {
  DELETION_TYPE_UNSPECIFIED: 0,
  DELETION_TYPE_DATA_ONLY: 1,
  DELETION_TYPE_ALL: 2,
};

goog.object.extend(exports, proto.yolabs.services.poplarfrontend);
